import script from "./DocumentThumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentThumb.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentThumb.vue?vue&type=style&index=0&id=7582eeb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7582eeb4"]])

export default __exports__